<template>
  <div :class="['journey light h-100 d-flex', theme ? `theme-${theme}` : '']">
    <div class="journey-main d-flex h-100 flex-column">
      <!-- <div class="classroom-header d-flex flex-column">
        <div class="logo">
          <img :src="logoDarkLandscape" />
        </div>
      </div> -->
      <div class="journey-body">
        <slot></slot>
      </div>
      <slot name="controls"></slot>
    </div>
    <slot name="sidePanel"></slot>
  </div>
</template>

<script setup>
import logoDarkLandscape from "@/assets/logo-dark-landscape.png";

const props = defineProps({
  theme: String
});

</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.journey {
  overflow: hidden;
  background-size: cover;

  &-main {
    flex: 1;
  }

  &-body {
    justify-content:flex-start; 
    overflow: auto;
    flex-grow: 1;
    margin: 0;
    flex-wrap:wrap;
    align-items: center;;
  }
}

.logo {
  padding: 2vh 0 1vh 0;
  text-align: center;
  margin: 0 auto;

  >img {
    width: 15vh;
  }
}
</style>
